import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import HistoryDetails from './HistoryDetails';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, selectedRequest, error, message,
  } = state.request;
  return {
    isLoading,
    selectedRequest,
    error,
    message,
  };
}

const Styled = withStyles(styles)(HistoryDetails);

export default connect(
  mapStateToProps,
)(Styled);
